import { CompanyContactsModel } from './companyContacts';
import { CompanyDocumentModel } from './companyDocument';


export class InitCompany {
    constitutionDate?: Date;
    businessName: string;
    document?: CompanyDocumentModel;
    contacts?: CompanyContactsModel;
    constructor() {
        this.constitutionDate = null;
        this.businessName = null;
        this.document = new CompanyDocumentModel();
        this.contacts = new CompanyContactsModel;
    }
}
